/**
 *  Most of this concept comes from https://rackt.github.io/redux/docs/recipes/ReducingBoilerplate.html
 */

import 'isomorphic-fetch';
import { CACHE_API_RESPONSE } from 'actions';

export default ({ dispatch, getState }) => next => (action) => {
  const {
    types,                       // ['LOAD_POSTS_REQUEST', 'LOAD_POSTS_SUCCESS', 'LOAD_POSTS_FAILURE']
    callAPI,                     // callAPI: () => fetch(`http://myapi.com/users/${userId}/posts`)
    payload = {},                // payload: { userId }
    shouldCallAPI = () => true,  // shouldCallAPI: (state) => !state.users[userId]
    onSuccess = () => true,      // Used to act on the response in a way that doesn't make sense for the store
    onError = () => true,        // Example: update localstorage when auth response success or error
  } = action;

  if (typeof callAPI === 'undefined') {
    // Normal action: pass it on
    return next(action);
  }

  if (!Array.isArray(types) || types.length !== 3 || !types.every(type => typeof type === 'string')) {
    throw new Error('Expected an array of three string types.');
  }

  if (typeof callAPI !== 'function') {
    throw new Error('Expected callAPI to be a function.');
  }

  const state = getState();

  if (!shouldCallAPI(state, dispatch)) {
    return true;
  }

  const [requestType, successType, failureType] = types;

  next(Object.assign({}, payload, {
    type: requestType,
  }));

  if (action.id && action.cacheable && state.apiCache.data[action.id]) {
    // Dispatch action with cached response immediately
    // Allow for normal request chain to proceed so an updated response is requested from API
    // This will prevent stale data from persisting in the cache but still allow for immediate screen draw
    next(Object.assign({}, payload, {
      response: state.apiCache.data[action.id],
      type: successType,
    }));
  }

  return callAPI(state).then(
    (response) => {
      if (action.id && action.cacheable) {
        dispatch({
          type: CACHE_API_RESPONSE,
          id: action.id,
          response,
        });
      }

      onSuccess(response, dispatch);
      return next(Object.assign({}, payload, {
        response,
        type: successType,
      }));
    },
    (error) => {
      onError(error, dispatch);
      return next(Object.assign({}, payload, {
        error,
        type: failureType,
      }));
    }
  );
};



// WEBPACK FOOTER //
// ./src/app/middleware/api.js